// @ts-nocheck
import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {Event} from '../../core/_models'

type Props = {
  column: ColumnInstance<Event>
}

const CustomHeaderColumn: FC<Props> = ({column}) => {
  if (column.Header && typeof column.Header === 'string') {
    const headerProps = column.getHeaderProps()
    const {key, ...restHeaderProps} = headerProps as any
    return <th key={key} {...restHeaderProps}>{column.render('Header')}</th>
  }

  return <>{column.render('Header')}</>
} 

export {CustomHeaderColumn}
